"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _styled = require("./styled");

var LoadingV2 = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(LoadingV2, _PureComponent);

  var _super = (0, _createSuper2["default"])(LoadingV2);

  function LoadingV2() {
    (0, _classCallCheck2["default"])(this, LoadingV2);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(LoadingV2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isLoading = _this$props.isLoading,
          children = _this$props.children,
          loadingText = _this$props.loadingText,
          color = _this$props.color;
      return isLoading ? /*#__PURE__*/_react["default"].createElement(_styled.Container, {
        container: true,
        alignItems: "center",
        justify: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Loading["default"], {
        loadingText: loadingText,
        color: color
      }))) : children;
    }
  }]);
  return LoadingV2;
}(_react.PureComponent);

exports["default"] = LoadingV2;
LoadingV2.defaultProps = {
  children: null,
  loadingText: null,
  color: undefined
};